// Module-scoped d3 v3 (3.5.5) for the legacy topography / text-collision plugins, which are
// v3-only (d3.scale / d3.mouse / d3.event / selection prototype patches). npm `d3` (v7) is a
// separate module and stays untouched. CJS on purpose: the d3.min.js UMD tail assigns
// `this.d3` unconditionally from a sloppy-mode IIFE (`this` = globalThis), so a bare import
// would clobber the window.d3 the stats page's script tag installs for legacy coffee —
// static imports hoist, only require() can be ordered around the save/restore.
const prevD3 = typeof window === 'undefined' ? undefined : window.d3

const d3 = require('@aytm-public/_d3/d3.min.js')

if (typeof window !== 'undefined') {
  if (prevD3 === undefined) delete window.d3
  else window.d3 = prevD3
}

module.exports = d3
